/*
Poornima 09/19/2022  2700912712 Fixed GAL- 122,127,128,130,161,163,170,171,173 bugs
Suresh Peddavoora 10/26/2022 2700912712 Removed Class Name for Text Fields.
T Santosh Kumar 10/30/2022 2701135832 UI Alignment changes for Filter Rule Group Screen
Prakash 10/31/2022 2701135832 Removed card.
Sohel 11/01/2022 3031450488 prepoulate table data.
Sohel 11/09/2022 3031450488 prepoulate Filter code.
akhila 11/26/2022 3031450488 passed overrideType in payload
Akhila 05/31/2023 3031450488 unsaved changes bug fixed
*/
import React, {useEffect} from 'react';
import RuleGroup from './RuleGroup';
import SystemNotes from './SystemNotes';
import {Typography} from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import {ExpandMore} from '@material-ui/icons';
import {useDispatch, useSelector} from 'react-redux';
import {resetData} from '../../../../../redux/reducers/BRE/AddRuleGroup';
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    'width': '100%',
    'backgroundColor': '#fff',
    'borderRadius': '4px',
    'border': '1px solid #f3f3f3',
    '& .MuiAccordionDetails-root': {
      display: 'block',
      whiteSpace: 'nowrap',
      padding: '10px',
      backgroundColor: '#fff',
    },
    '& .MuiAccordionSummary-root': {
      backgroundColor: '#f3f3f3',
    },
  },
  heading: {
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 600,
    flexBasis: '50%',
    flexShrink: 0,
    marginLeft: 8,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  detailsText: {
    backgroundColor: '#FFF',
    padding: 10,
    boxShadow:
      '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
  },
  accountSpan: {
    'backgroundColor': '#38FA8A',
    'padding': '3px 10px',
    'borderRadius': 50,
    '& .MuiTypography-body1': {
      fontSize: '12px !important',
      fontWeight: 600,
      marginTop: '3px',
      color: '#FFF',
    },
  },
  detailsCard: {
    padding: 10,
    borderRadius: '0px 0px 8px 8px',
    backgroundColor: '#fbfbfb',
  },

  cardStyles: {
    whiteSpace: 'nowrap',
    padding: '0 15px',
  },
  labelName: {
    '& .MuiOutlinedInput-input': {
      fontSize: '13px',
    },
  },
  inputLabel: {
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      fontWeight: '600',
    },
  },
  selectGender: {
    fontSize: '13px',
  },
  selectLabel: {
    fontWeight: '600 !important',
  },
  datePicker: {
    '& .MuiIconButton-root': {
      'padding': '0px !important',
      ' & .MuiSvgIcon-root': {
        fontSize: '1.3rem',
      },
    },
    '& .MuiOutlinedInput-input': {
      fontSize: '13px',
    },
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: '6px',
    },
  },
  textField: {
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: '40px !important',
    },
  },
  popper: {
    zIndex: '9 !important',
  },
}));

function AddFilterRuleGroup({
  setValue,
  setBreCode,
  breCode,
  setTabValue,
  dataReset,
  rowSelected,
  setShowFilterData,
  StepperFilter,
  isCopy,
  fieldListCode,
  setRuleGroupCode,
  setGroupId,
  overrideType,
  handleDirty,
}) {
  const [expanded, setExpanded] = React.useState();
  const {ruleGroupData} = useSelector(({addRuleGroup}) => addRuleGroup);
  const [selectedBaseCategory, setSelectedBaseCategory] = React.useState(
    ruleGroupData?.category ? ruleGroupData.category : '',
  );
  const dispatch = useDispatch();
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  useEffect(
    () => () => {
      dispatch(resetData());
    },
    [],
  );
  const classes1 = useStyles();
  return (
    <>
      <div>
        <RuleGroup
          dataReset={dataReset}
          setValue={setValue}
          setTabValue={setTabValue}
          selectedBaseCategory={selectedBaseCategory}
          setSelectedBaseCategory={setSelectedBaseCategory}
          rowSelected={rowSelected}
          setShowFilterData={setShowFilterData}
          StepperFilter={StepperFilter}
          isCopy={isCopy}
          fieldListCode={fieldListCode}
          setRuleGroupCodeData={setRuleGroupCode}
          setGroupId={setGroupId}
          overrideType={overrideType}
          handleDirty={handleDirty}
        />

        {breCode && !dataReset && (
          <div className={classes1.root}>
            <Accordion
              className="accordion-styling"
              elevation={0}
              expanded={expanded === 'panel1'}
              onChange={handleChange('panel1')}
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                aria-controls="panel1d-content"
                id="panel1d-header"
              >
                <Typography className={classes1.heading}>Filter Rule Group Notes</Typography>
              </AccordionSummary>
              <AccordionDetails className={classes1.detailsCard}>
                <SystemNotes setBreCode={setBreCode} breCode={breCode} />
              </AccordionDetails>
            </Accordion>
          </div>
        )}
      </div>
    </>
  );
}

export default AddFilterRuleGroup;
